var map = {
	"./animals/cat.svg": "V6aO",
	"./animals/chicken.svg": "Mqqi",
	"./animals/dog.svg": "qMu6",
	"./animals/dolphin.svg": "kxa0",
	"./animals/duck.svg": "Fukp",
	"./animals/elephant.svg": "Q2DA",
	"./animals/fish.svg": "ZE1l",
	"./animals/flamingo.svg": "nJKb",
	"./animals/giraffe.svg": "Vfl6",
	"./animals/horse.svg": "Kjs/",
	"./animals/monkey.svg": "/y4W",
	"./animals/owl.svg": "Nobk",
	"./animals/panda.svg": "qfOy",
	"./animals/penguin.svg": "e6fi",
	"./animals/rabbit.svg": "fSSA",
	"./animals/sheep.svg": "04Ov",
	"./animals/toucan.svg": "9WyV",
	"./animals/turtle.svg": "BHIp",
	"./beer-wine/barrel.svg": "ymAH",
	"./beer-wine/field-color.svg": "VTTB",
	"./beer-wine/field.svg": "5gh+",
	"./beer-wine/grapes-color.svg": "aE8G",
	"./beer-wine/grapes.svg": "7XL6",
	"./beer-wine/hop-color.svg": "EcCi",
	"./beer-wine/hop.svg": "qhIr",
	"./beer-wine/mug-color.svg": "s0Yg",
	"./beer-wine/mugs.svg": "YvOO",
	"./beer-wine/wheat-color.svg": "rGP8",
	"./beer-wine/wheat.svg": "FKt6",
	"./beer-wine/wine-glass.svg": "aBQO",
	"./birthday/balloons.svg": "kOfL",
	"./birthday/cake.svg": "svKc",
	"./birthday/cake2.svg": "jOqN",
	"./birthday/candies.svg": "torD",
	"./birthday/candle.svg": "Q7vL",
	"./birthday/candles.svg": "bI4M",
	"./birthday/champagne.svg": "L52S",
	"./birthday/confetti.svg": "KsE+",
	"./birthday/fireworks.svg": "lTlW",
	"./birthday/garlands.svg": "iraO",
	"./birthday/gifts.svg": "RsMr",
	"./birthday/party-hat.svg": "FJ+x",
	"./characters/batman.svg": "3VnI",
	"./characters/clown.svg": "Qyxe",
	"./characters/cowboy.svg": "YKZg",
	"./characters/deadpool.svg": "lVY8",
	"./characters/knight.svg": "5SpM",
	"./characters/lego.svg": "NfKw",
	"./characters/ninja.svg": "YU+o",
	"./characters/pirate.svg": "nRYI",
	"./characters/queen.svg": "RTLv",
	"./characters/santa-claus.svg": "NSTa",
	"./characters/spiderman.svg": "w33J",
	"./characters/superman.svg": "LxAo",
	"./christmas/bauble.svg": "99xU",
	"./christmas/bell.svg": "zc0V",
	"./christmas/biscuit.svg": "2qvV",
	"./christmas/christmas-gift.svg": "p7yH",
	"./christmas/knot.svg": "29iQ",
	"./christmas/letter.svg": "S4Np",
	"./christmas/sock.svg": "VEBo",
	"./christmas/star-anise.svg": "1EFv",
	"./christmas/star.svg": "qXYj",
	"./decoration/deco-black1.svg": "X1nj",
	"./decoration/deco-black2.svg": "lGTJ",
	"./decoration/deco-black3.svg": "k41P",
	"./decoration/deco-black4.svg": "3spL",
	"./decoration/deco-black5.svg": "pZHB",
	"./decoration/deco-black6.svg": "KbXF",
	"./decoration/deco1.svg": "4Xyd",
	"./decoration/deco2.svg": "nfVb",
	"./decoration/deco3.svg": "L9IJ",
	"./decoration/deco4.svg": "sCvC",
	"./decoration/deco5.svg": "QBZ0",
	"./decoration/deco6.svg": "Tg51",
	"./entertainment/camera.svg": "TXIo",
	"./entertainment/carousel.svg": "y8C3",
	"./entertainment/dice.svg": "QENj",
	"./entertainment/film.svg": "Vzb5",
	"./entertainment/gameboy.svg": "EK2i",
	"./entertainment/magic.svg": "xA1f",
	"./entertainment/playing-cards.svg": "Hgsr",
	"./entertainment/sportcar.svg": "df6f",
	"./entertainment/theater.svg": "fbB7",
	"./entertainment/vinyl.svg": "bacl",
	"./foods/bread.svg": "VFrt",
	"./foods/cheese.svg": "z7LP",
	"./foods/crab.svg": "1AYN",
	"./foods/cupcake.svg": "mUuH",
	"./foods/fish-meat.svg": "kRvu",
	"./foods/icecream.svg": "qptW",
	"./foods/lobster.svg": "UELC",
	"./foods/meat.svg": "SPie",
	"./foods/milk.svg": "Bivo",
	"./foods/poultry.svg": "OIX6",
	"./foods/sausage.svg": "kuoL",
	"./foods/sweet.svg": "DSLQ",
	"./fruits/abricot.svg": "onwC",
	"./fruits/almond.svg": "Toxl",
	"./fruits/apple.svg": "Zm5Z",
	"./fruits/banana.svg": "QTSz",
	"./fruits/blackberry.svg": "fTk+",
	"./fruits/blackcurrant.svg": "XxRy",
	"./fruits/blueberry.svg": "lSQa",
	"./fruits/cherry.svg": "9MHh",
	"./fruits/chestnut.svg": "D9TP",
	"./fruits/clementine.svg": "P+Z3",
	"./fruits/coconut.svg": "L5qa",
	"./fruits/fig.svg": "KTwB",
	"./fruits/grape.svg": "Mnjl",
	"./fruits/hazelnut.svg": "P8n+",
	"./fruits/kiwi.svg": "IB++",
	"./fruits/lemon.svg": "lcBX",
	"./fruits/mango.svg": "i7qQ",
	"./fruits/melon.svg": "UP6P",
	"./fruits/mirabelle.svg": "/eLU",
	"./fruits/orange.svg": "5ZI5",
	"./fruits/peach.svg": "kMFB",
	"./fruits/peanut.svg": "LX43",
	"./fruits/pear.svg": "Cs1z",
	"./fruits/persimmon.svg": "1Wna",
	"./fruits/pistachio.svg": "mpoE",
	"./fruits/plum.svg": "aoxX",
	"./fruits/quince.svg": "/30Y",
	"./fruits/raspberry.svg": "+TQb",
	"./fruits/red-berries1.svg": "WVU/",
	"./fruits/red-berries2.svg": "1kgT",
	"./fruits/redcurrant.svg": "YmzX",
	"./fruits/rhubarb.svg": "7WbG",
	"./fruits/strawberry.svg": "SGMg",
	"./fruits/walnut.svg": "mVFs",
	"./fruits/watermelon.svg": "0n/e",
	"./herbs-spices/anise.svg": "LtnP",
	"./herbs-spices/basil.svg": "yPkx",
	"./herbs-spices/cinnamon.svg": "9rDS",
	"./herbs-spices/clove.svg": "tvy9",
	"./herbs-spices/curry.svg": "yTkc",
	"./herbs-spices/ginger.svg": "bPSp",
	"./herbs-spices/mint.svg": "by8d",
	"./herbs-spices/nutmeg.svg": "hHiD",
	"./herbs-spices/parsley.svg": "Uclj",
	"./herbs-spices/saffron.svg": "Y9f7",
	"./herbs-spices/vanilla.svg": "zvym",
	"./kitchen/bowl.svg": "F8sA",
	"./kitchen/coffee.svg": "HqOD",
	"./kitchen/cooker.svg": "8gbo",
	"./kitchen/jar.svg": "DMGO",
	"./kitchen/salt-pepper.svg": "nMID",
	"./kitchen/terrine.svg": "WGST",
	"./pots/honey.svg": "Zmc7",
	"./pots/jam1.svg": "eU+1",
	"./pots/jam2.svg": "DOgB",
	"./pots/jam3.svg": "Cpo9",
	"./pots/pot-leaf.svg": "/eLV",
	"./pots/pot-spoon.svg": "xLXb",
	"./pots/pot-spoon2.svg": "8zSr",
	"./pots/pot1.svg": "qxZo",
	"./pots/pot2.svg": "5bBT",
	"./pots/pot3.svg": "ADMC",
	"./pots/pot4.svg": "Lw78",
	"./school/abc.svg": "vYn6",
	"./school/art.svg": "2AyE",
	"./school/biology.svg": "XnV3",
	"./school/book.svg": "0XgQ",
	"./school/books.svg": "QFUy",
	"./school/chemistry.svg": "endW",
	"./school/computer.svg": "8sBC",
	"./school/english.svg": "osuY",
	"./school/france.svg": "nnb6",
	"./school/geography.svg": "fNoH",
	"./school/germany.svg": "LChb",
	"./school/history.svg": "08KM",
	"./school/mathematics.svg": "LlFE",
	"./school/microscope.svg": "bnu/",
	"./school/music.svg": "Ashs",
	"./school/pens.svg": "hZw8",
	"./school/podium.svg": "hNF2",
	"./school/rulers.svg": "CMDH",
	"./school/science.svg": "YXqq",
	"./school/spain.svg": "8Mi1",
	"./school/telescope.svg": "ndBn",
	"./sports/badminton.svg": "nz0C",
	"./sports/basketball.svg": "NrpV",
	"./sports/bicycle.svg": "NHCd",
	"./sports/football.svg": "gIER",
	"./sports/golf.svg": "DF6p",
	"./sports/ping-pong.svg": "yEJI",
	"./sports/rugby.svg": "FxiM",
	"./sports/runner.svg": "+jx4",
	"./sports/sail.svg": "VDc3",
	"./sports/skateboard.svg": "OomE",
	"./sports/tennis.svg": "1e48",
	"./sports/volleyball.svg": "STHJ",
	"./vegetables/asparagus.svg": "Gbpm",
	"./vegetables/aubergine.svg": "Npxf",
	"./vegetables/beetroot.svg": "NJFz",
	"./vegetables/broccoli.svg": "9vna",
	"./vegetables/cabbage.svg": "ABoK",
	"./vegetables/carrot.svg": "NDAH",
	"./vegetables/cauliflower.svg": "T8Z3",
	"./vegetables/chilli-pepper.svg": "klA8",
	"./vegetables/corn.svg": "FIBm",
	"./vegetables/courgette.svg": "QexL",
	"./vegetables/cucumber.svg": "lx5r",
	"./vegetables/garlic.svg": "dlv1",
	"./vegetables/leek.svg": "QfCY",
	"./vegetables/mushroom.svg": "3lS0",
	"./vegetables/olive.svg": "FDAq",
	"./vegetables/onion.svg": "r2Gk",
	"./vegetables/peas.svg": "seZ0",
	"./vegetables/pepper.svg": "BLcR",
	"./vegetables/pickle.svg": "RnQk",
	"./vegetables/potato.svg": "kGLo",
	"./vegetables/pumpkin.svg": "E33q",
	"./vegetables/radish.svg": "//Kb",
	"./vegetables/shallot.svg": "7xuO",
	"./vegetables/tomato.svg": "iicZ",
	"./wedding/arrow.svg": "6hGV",
	"./wedding/bride-bicycle.svg": "wTKb",
	"./wedding/bride-car.svg": "D8Uy",
	"./wedding/bride-champagne.svg": "pYhv",
	"./wedding/bride-flowers.svg": "V5m2",
	"./wedding/bride-heart.svg": "BalV",
	"./wedding/bride.svg": "aP13",
	"./wedding/dove.svg": "om/K",
	"./wedding/heart-circle.svg": "V95X",
	"./wedding/heart.svg": "SVQi",
	"./wedding/love.svg": "GAuU",
	"./wedding/ring.svg": "xzGD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "P6mx";